// Mutations
export const STORE_ACCESS_TOKEN = 'storeAccessToken';
export const STORE_ACCOUNTS = 'storeAccounts';
export const STORE_REFRESH_TOKEN = 'storeRefreshToken';
export const STORE_USER_DATA = 'storeUserData';
export const PURGE_AUTH = 'purgeAuth';

// Actions
export const LOGIN = 'login';
export const LOGIN_WITH_PASSWORD = 'loginWithPassword';
export const GENERATE_ACCESS_TOKEN = 'generateAcessToken';
export const FETCH_USER_INFO = 'fetchUserInfo';
